var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronSelectorVerticalSvg from './chevron-selector-vertical.icon.svg';
export const ChevronSelectorVerticalIcon = (iconInstanceProps) => _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronSelectorVerticalSvg });
_react_refresh_temp_1 = ChevronSelectorVerticalIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronSelectorVerticalIcon");
